// extracted by mini-css-extract-plugin
export default {"root":"gXuqUDMHCfIn256n5uZf","item":"poxCXFzfxc7QgtAtc7wu","title":"gO4pfJPzlYd20Vt9oaBQ","content":"ot5xNcU3_cIj0ufbPeA9"};